import { createContext, useContext } from "react";

export type SettingsState = {
  showBaseModal: boolean;
  showPlaybackRateModal: boolean;
  showResolutionsModal: boolean;
};

export type SettingsActions = {
  setShowBaseModal: (show: boolean) => void;
  setShowPlaybackRateModal: (show: boolean) => void;
  setShowResolutionsModal: (show: boolean) => void;
};

export const SettingsContext = createContext<
  (SettingsState & SettingsActions) | undefined
>(undefined);

export const useSettings = (): SettingsState & SettingsActions => {
  const context = useContext(SettingsContext);

  if (context === undefined) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }

  return context;
};
